import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import {
    Col,
    Form,
    FormInstance,
} from 'antd';
import { getPieceLevelFieldFromMapping } from '../generic-sub-layout-renderer';
import { uniqueId } from 'lodash';
import { nonDocumentFieldStyles } from './non-document-field.styles';

interface IProps extends StylesProps<ReturnType<typeof nonDocumentFieldStyles>>, ReturnType<typeof mapStateToProps> {
    form: FormInstance;
    params: any;
}

const NonDocumentField = (props: IProps) => {
    const {
        form,
        params,
        classes,
    } = props;

    const nonDocumentLayout = params?.subLayout?.non_document || [];

    const { ItemType } = formFields;

    const itemType = Form.useWatch(ItemType.key, form);

    if (itemType && itemType !== 'non-document') {
        return null;
    }

    const nonDocumentComponent = (
        <>
            {nonDocumentLayout?.map((fieldKey: any) => getPieceLevelFieldFromMapping(fieldKey, form, params))}
        </>
    );

    return (
        <div
            className={classes.nonDocumentFieldContainer}
            key={uniqueId() + (+new Date())}
        >
            <Col span={24}>
                {nonDocumentComponent}
            </Col>
        </div>
    );
};

const mapStateToProps = () => ({});

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: nonDocumentFieldStyles,
    },
};

export default GenericHoc(hocConfig)(NonDocumentField);
